<template>
  <v-btn icon :title="title" @click="onClick">
    <v-icon color="primary">mdi-magnify</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'ShowIconButton',
  props: {
    title: {
      default () {
        return this.$t('general.show');
      }
    }
  },
  methods: {
    onClick () {
      this.$emit('click');
    }
  }
}
</script>
